<template>
  <div>
    <div class="menu">
      <span
        class="menutoggle"
        :class="{ menuclose: isActive }"
        @click="showMenu()"
      >
      </span>
      <br />
      <div class="menu-menu" :class="{ hide: !isActive }">
        <router-link class="menua" :to="{ name: 'quote' }"
          >Get a Quote</router-link
        >
        <modal-links :modals="homeModals" title="home" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ModalLinks from "@/views/partials/ModalLinks.vue";
import { ModalsArr } from "@/utils/ModalsArr";
import { Ref, ref, provide, watch } from "vue";
import { useMenuStore } from "@/stores/root/menu";

const homeModals = ModalsArr;
const menuStore = useMenuStore();
const isActive: Ref<boolean> = ref(false);

watch(menuStore, (current) => {
  current.isActive ? (isActive.value = true) : (isActive.value = false);
});

function showMenu() {
  menuStore.active();
}
</script>
